import React from "react";
import {connect} from "react-redux";

const BasicCarrouselFeeder = ({data, dark}) => data.map(({source}, index) => <div style={{backgroundColor: dark ? "#212121" : "#EEEEEE"}} key={index}><iframe className="w-75 h-auto" src={source}/></div>);

const mapStateToProps = state => ({dark:state.dark});

export default connect(mapStateToProps, {})(BasicCarrouselFeeder);